import menu from './menu';
import notifications from './notifications';

export default {
    rootPath: window.env.APP_URL,
    cmsPath: '/admin',
    cmsTitle: window.env.APP_NAME,
    routes: {
        default: '/dashboard',
        endpoints: {
            '^/pages': {
                params: { filter: 'parent_id$id' },
            },
            '^/panels': {
                params: { filter: 'content_id:$null' },
            },
            '^/categories': {
                params: { filter: 'parent_id$id' },
            },
            '^/enquiries': {
                params: { sort: 'created_at:desc' }
            },
            '^/applications': {
                params: { sort: 'created_at:desc' }
            },
            '^/subscribers': {
                params: { sort: 'created_at:desc' }
            },
            '^/application/[0-9]+/oxford': {
                params: { per_page: 10, sort: 'created_at:desc' }
            },
        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            csv: ['csv'],
        }
    },
    menu,
    notifications,
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/base.js